import * as React from 'react';
import { BreakpointProvider, registerBreakpoints } from '@avensia/excite';
import { breakpoints } from 'webapp/breakpoints';
import { NordicnestNinetailedProvider } from 'webapp/ninetailed/NinetailedProvider';
import { CurrentPageProvider } from '@avensia/excite/current-page/context';
import { GlitzServer, type Theme } from '@glitz/core';
import { glitz } from 'webapp/glitz';
import { GlitzProvider, ThemeProvider } from '@glitz/react';

registerBreakpoints(breakpoints);

type AppProvidersProps = React.PropsWithChildren<{ theme: Theme }>;

export function AppProviders(props: AppProvidersProps) {
  return (
    <CurrentPageProvider>
      <GlitzProvider glitz={__BROWSER__ ? glitz : (glitz as GlitzServer).clone()} stream>
        <ThemeProvider theme={props.theme}>
          <NordicnestNinetailedProvider>
            <BreakpointProvider>{props.children}</BreakpointProvider>
          </NordicnestNinetailedProvider>
        </ThemeProvider>
      </GlitzProvider>
    </CurrentPageProvider>
  );
}
